import { JobT, VariableExpenseT } from '../../../../types/Job'
import { convertItemByWorker } from '../JobUtils'
import * as _ from 'lodash'

export interface CogsLineItemT {
  id: string
  date: string
  item: string
  rate: number
  total: number
  units: number
  isDirty?: boolean
  isAutoFill?: boolean
  paid?: boolean
  amountPaid?: number | null
  workerId?: number | null
}

export const mergeOptions = (...rules) => {
  return rules.filter(Boolean).reduce((result, rule) => {
    return { ...result, ...rule }
  }, {})
}

export const generateOptionsCogsForCrew = (job: JobT, OptionsItemsCogs: { [k: string]: VariableExpenseT }) => {
  let options: { [k: string]: VariableExpenseT } = {}
  job.crew.map((crew, indexCrew) => {
    const resultLaborFlat = convertItemByWorker(crew, 'laborFlat', indexCrew)
    options[`${resultLaborFlat.key}`] = {
      ...OptionsItemsCogs.laborFlat, ...{
        verboseName: `${OptionsItemsCogs.laborFlat.verboseName} - ${_.startCase(resultLaborFlat.variableName)}`,
        value: crew.hourlyRate
      }
    }
    const resultLaborVariable = convertItemByWorker(crew, 'laborVariable', indexCrew)
    options[`${resultLaborVariable.key}`] = {
      ...OptionsItemsCogs.laborVariable, ...{
        verboseName: `${OptionsItemsCogs.laborVariable.verboseName} - ${_.startCase(resultLaborVariable.variableName)}`,
        value: crew.hourlyRate
      }
    }
  })
  return options
}
